import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';

const ripple = keyframes`
  0% {
    transform: scale(0.8);
    opacity: 1;
  }
  100% {
    transform: scale(3);
    opacity: 0;
  }
`;

const ProcessingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

const ProcessingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

const WaveContainer = styled.div`
  position: relative;
  width: 200px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Wave = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 2px solid rgba(124, 58, 237, 0.5);
  animation: ${ripple} 2s ease-out infinite;
  animation-delay: ${props => props.delay}s;
`;

const TimerCircle = styled.div`
  position: relative;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: linear-gradient(135deg, #7C3AED 0%, #A855F7 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 40px rgba(124, 58, 237, 0.5);
  z-index: 1;
`;

const TimerText = styled.div`
  font-size: 48px;
  color: white;
`;

const StatusText = styled.div`
  font-size: 24px;
  font-weight: 600;
  color: white;
  text-align: center;
`;

const SubText = styled.div`
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  text-align: center;
`;

const PaymentProcessing = ({ onComplete }) => {
  const [timeLeft, setTimeLeft] = useState(10);

  useEffect(() => {
    if (timeLeft <= 0) {
      onComplete();
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft, onComplete]);

  return (
    <ProcessingOverlay>
      <ProcessingContainer>
        <WaveContainer>
          <Wave delay={0} />
          <Wave delay={0.5} />
          <Wave delay={1} />
          <Wave delay={1.5} />
          <TimerCircle>
            <TimerText>{timeLeft}</TimerText>
          </TimerCircle>
        </WaveContainer>
        
        <StatusText>Processing Payment...</StatusText>
        <SubText>Confirming transaction on the blockchain</SubText>
      </ProcessingContainer>
    </ProcessingOverlay>
  );
};

export default PaymentProcessing;